import {AssetFinanceTier1} from '../admin-service.domain';

export type AssetTier1Value = AssetFinanceTier1 | null;
